import { getImageUrl } from '@website/components/media/utils/imgix';
import {
  GetHostDashboardDataQuery,
  Status,
} from '@website/types/graphqlOperations';
import Link from 'next/link';
import { Badge, Button, Card, Col, Row } from 'react-bootstrap';
import Imgix from 'react-imgix';

interface HostTripButtonsProps {
  trips: GetHostDashboardDataQuery['hostByURL']['trips']['items'];
}

/**
 * Sort trips
 *
 * Sort so that inactive trips are on the bottom, and then sort alphabetically
 */
export function sortTrips(
  a: Pick<
    GetHostDashboardDataQuery['hostByURL']['trips']['items'][0],
    'active' | 'title'
  >,
  b: Pick<
    GetHostDashboardDataQuery['hostByURL']['trips']['items'][0],
    'active' | 'title'
  >,
): number {
  if (a.active !== b.active) {
    if (a.active === Status.ACTIVE) {
      return -1;
    }
    return 1;
  }

  if (a.title < b.title) {
    return -1;
  }
  return 1;
}

export default function HostTripCards({ trips }: HostTripButtonsProps) {
  const sortedTrips = [...trips].sort(sortTrips);

  return (
    <Row>
      {sortedTrips.map((trip) => (
        <Col xs={12} sm={6} md={4} lg={3} key={trip.id} className="px-3 py-3">
          <Card
            className={`h-100 ${
              trip.active === Status.INACTIVE ? 'border-warning' : ''
            }`}
          >
            <Link
              href={`/trips/${trip.slug}`}
              passHref
              className="text-decoration-none"
            >
              <Imgix
                src={`${getImageUrl(trip.image.file.key)}`}
                imgixParams={{
                  auto: 'compress,format,enhance,redeye',
                  crop: 'faces,entropy',
                  fit: 'crop',
                  ar: `${16 / 10}:1`, // Aspect ratio
                }}
                htmlAttributes={{
                  alt: trip.title,
                }}
                className="card-img-top w-100 h-100"
                sizes="(min-width: 1400px) 420px, (min-width: 1200px) 360px, (min-width: 992px) 299px, (min-width: 768px) 220px, (min-width: 576px) 208px, 100vw"
              />
            </Link>
            <Card.Body>
              <Link href={`/trips/${trip.slug}`} passHref>
                <Card.Title as={'a'} className="text-dark h5 fw-bold">
                  {trip.title}
                  {trip.active === Status.INACTIVE && (
                    <small>
                      <Badge bg="warning" className="ms-1">
                        Inactive
                      </Badge>
                    </small>
                  )}
                </Card.Title>
              </Link>
            </Card.Body>
            <Card.Footer>
              <Link href={`/trips/${trip.slug}/edit`} passHref legacyBehavior>
                <Button variant={'outline-primary'} size="sm" as="a">
                  Edit Trip
                </Button>
              </Link>
            </Card.Footer>
          </Card>
        </Col>
      ))}
    </Row>
  );
}
